var _style, _path, _circle, _rect, _rect2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 650",
    style: {
      enableBackground: "new 0 0 650 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#000000;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325,62.2c-155.6,0-281.7,126.1-281.7,281.7S169.4,625.7,325,625.7s281.7-126.1,281.7-281.7 S480.6,62.2,325,62.2z M325,555.2c-116.7,0-211.3-94.6-211.3-211.3S208.3,132.6,325,132.6s211.3,94.6,211.3,211.3 S441.7,555.2,325,555.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 323.1,
    cy: 343.9,
    r: 25.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 297.3,
    y: 161.4,
    className: "st0",
    width: 51.6,
    height: 208.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 327.5,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 919.7625 430.2511)",
    className: "st0",
    width: 51.6,
    height: 156.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.3,191.5c31.1-55.8,78.9-101.1,136.5-129.3c-17-26.4-46.7-43.8-80.4-43.8c-52.8,0-95.6,42.8-95.6,95.6 C11.8,146,27.4,174.2,51.3,191.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.5,62.4c57.3,28.2,105,73.6,136.1,129.7c25.4-18.4,41.3-48.9,39.6-82.5c-2.7-52.7-47.7-93.3-100.4-90.6 C506,20.6,478.6,37.6,462.5,62.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrow);
export default __webpack_public_path__ + "static/media/Borrow.7fe868b2.svg";
export { ForwardRef as ReactComponent };